// Cross-runtime hook for the CBR FX snapshot. Both `OverviewTab` and
// `PickWinnerModal` consume this; the shared React-Query cache means a
// single network call regardless of which is mounted. `staleTime` of 6h
// matches the daily refresh cadence.

import { useQuery } from '@tanstack/react-query';
import { CurrencyRatesSchema, type CurrencyRates } from '@magimp/shared';
import { useApiClient } from '../api/context.js';

const SIX_HOURS_MS = 6 * 60 * 60 * 1000;

export function useCurrencyRates() {
  const client = useApiClient();
  return useQuery<CurrencyRates>({
    queryKey: ['currency-rates'],
    queryFn: ({ signal }) =>
      client.get<CurrencyRates>('/currency-rates', { signal }, CurrencyRatesSchema),
    staleTime: SIX_HOURS_MS,
    refetchOnWindowFocus: false,
  });
}
